import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser, setReturnURL} from '../../utils/commonfunction';
import { ROLE } from "../../utils/Constants";

const CenterDoctorPrivateRoute = ({ component: Component, role }) => {
    let userData = getUser(ROLE.CENTER);
    if(!Object.keys(userData).length){
        userData = getUser(ROLE.DOCTOR);
    }
    const userRole = role || (Object.keys(userData).length ? userData.role : null);

    // console.log("____",userData)
    return (
        <>
            {(function(){
                // console.log("userData",userData)
                if(Object.keys(userData).length && userData.token && (userData.role == ROLE.CENTER || userData.role == ROLE.DOCTOR)  ){
                    return <Component userRole = {userRole}/>
                }else{
                    if(userRole == ROLE.CENTER){
                        setReturnURL(ROLE.CENTER);
                    }else{
                        setReturnURL(ROLE.DOCTOR);
                    }
                    return <Navigate to="/" />;
                }
            })()}
        </>
    )
}

export default CenterDoctorPrivateRoute;
